import 'bootstrap'
import $ from 'jquery'

const initializeHelperText = function() {
  $('.helper-text').popover()
}

export default initializeHelperText

